import type { ReactNode } from "react"

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@coval/ui"

interface NotebookDetailHeaderProps {
  homeHref: string
  notebooksHref: string
  title: string | null
  /** The notebook's dot menu, rendered at the right edge. */
  menu?: ReactNode
}

/** Top-bar breadcrumb for a notebook: Sofia › Notebooks › title, menu on the right. */
export function NotebookDetailHeader({
  homeHref,
  notebooksHref,
  title,
  menu,
}: NotebookDetailHeaderProps) {
  return (
    <div className="flex w-full min-w-0 items-center gap-4">
      <Breadcrumb className="min-w-0">
        <BreadcrumbList className="flex-nowrap">
          <BreadcrumbItem>
            <BreadcrumbLink
              href={homeHref}
              className="text-sm text-coval-text hover:underline"
            >
              Sofia
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink
              href={notebooksHref}
              className="text-sm text-coval-text hover:underline"
            >
              Notebooks
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem className="min-w-0">
            <BreadcrumbPage
              className="block max-w-[48ch] truncate"
              data-testid="notebook-detail-title"
            >
              {title || "Notebook"}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      {menu ? <div className="ml-auto shrink-0">{menu}</div> : null}
    </div>
  )
}
